const defaultCompanies = [];
const companyGroups = (state = defaultCompanies, action) => {
  switch (action.type) {
    case 'COMPANY_GROUP_LIST_SUCCESS':
      return action.companyGroupList;
    default:
      return state;
  }
};

export default companyGroups;
